"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "templates",
    path: "/templates",
    component: "Templates"
});
(0, core_1.addRoute)({
    name: "templates.template",
    path: ":id",
    component: "Template",
    params: [{
            name: "id",
            prop: "resourceId",
        },
    ]
});
let Templates = class Templates extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_contextData = new core_1.ComponentValueCache(this, "contextData", "Template.sampleData");
    }
    onOptionSelected(...args) {
        const [option] = args;
        this.$router.replace({
            name: 'app.templates.template',
            params: { id: option.id }
        });
    }
    getSelectedItemId(...args) {
        if (this.$route.params && this.$route.params.id) {
            return this.$route.params.id;
        }
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    items;
    async $$load_items() {
        return this.$fn.fetch('list_template').then(d => _.sortBy(d, 'created_at'));
    }
    oid;
    async $$load_oid() {
        return this.getSelectedItemId();
    }
    optionTemplate;
    selectedValueInternal;
    async $$load_selectedValueInternal() {
        return this.selectedValue;
    }
    item;
    async $$load_item() {
        return this.oid
            ? this.$fn.fetch('read_template', { asResource: true, parameters: { id: this.oid } })
            : null;
    }
    editor;
    async $$load_editor() {
        return this.item ? this.item.editor() : null;
    }
    contextData;
    async $$load_contextData() {
        return { sampleData: null };
    }
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formId', 'formName', 'items', 'oid', 'optionTemplate', 'selectedValueInternal', 'item', 'editor', 'contextData', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                formName: "template",
                items: null,
                oid: null,
                optionTemplate: "<div>\n\
  {{ option.name }}\n\
  ({{ option.object_type }})\n\
</div>\n\
",
                selectedValueInternal: null,
                item: null,
                editor: null,
                contextData: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get sampleData() {
        if (this.loaded) {
            return this.contextData.sampleData;
        }
        return null;
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("Templates", "Templates"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4864_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_script_4868_getActionArgs_value($event) {
        this.onOptionSelected($event.data.option);
    }
    async act_6466705138206980_script_4868_getActionArgs($event) {
        return {
            value: () => this.act_6466705138206980_script_4868_getActionArgs_value($event),
        };
    }
    async evh_6466705138206980_optionSelected(event, scope) {
        return await this.actions.evh_6466705138206980_optionSelected.executeFromDOM(this, event, scope);
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8116269939469002_showModal_4872_getActionArgs($event) {
        return {
            name: "TemplatePreview",
            props: {
                item: this.item,
                sampleData: this.contextData.sampleData,
            },
        };
    }
    async evh_8116269939469002_clickPreventStop(event, scope) {
        return await this.actions.evh_8116269939469002_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1655522927138420_showModal_4874_getActionArgs($event) {
        return {
            name: "FileSelector",
            props: {
                url: this.$fn.urlFor('read_template', { id: 'import' }),
                accept: ".yaml",
            },
        };
    }
    async evh_1655522927138420_clickPreventStop(event, scope) {
        return await this.actions.evh_1655522927138420_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_setData_4878_getActionArgs($event) {
        return {
            path: "item",
            value: $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1040167445267876_success_4877_getWhen($event) {
        return $event.data.response.data;
    }
    async act_1040167445267876_rest_4876_getActionArgs($event) {
        return {
            method: "save",
            container: {
                self: this.item.links.parent,
                object: 'list',
                data: []
            },
            resource: this.editor,
        };
    }
    async evh_1040167445267876_submit(event, scope) {
        return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4864 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4864_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4863 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4864,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4863],
        });
        const act_2248226175642056_closeModal_4866 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_4865 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_4866,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_4865],
        });
        const act_6466705138206980_script_4868 = new core_1.actions.ScriptAction({
            actionArgs: this.act_6466705138206980_script_4868_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_optionSelected_4867 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_script_4868,
            event: "optionSelected",
            displayName: "script",
        });
        const evh_6466705138206980_optionSelected = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_optionSelected_4867],
        });
        const act_8320016629450276_reloadComponentData_4870 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_8320016629450276_clickPreventStop_4869 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadComponentData_4870,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_4869],
        });
        const act_8116269939469002_showModal_4872 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8116269939469002_showModal_4872_getActionArgs,
            events: [],
        });
        const evh_8116269939469002_clickPreventStop_4871 = new core_1.actions.EventHandlerImpl({
            action: act_8116269939469002_showModal_4872,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8116269939469002_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8116269939469002_clickPreventStop_4871],
        });
        const act_1655522927138420_showModal_4874 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1655522927138420_showModal_4874_getActionArgs,
            events: [],
        });
        const evh_1655522927138420_clickPreventStop_4873 = new core_1.actions.EventHandlerImpl({
            action: act_1655522927138420_showModal_4874,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_1655522927138420_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1655522927138420_clickPreventStop_4873],
        });
        const act_1040167445267876_setData_4878 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_4878_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_success_4877 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_4878,
            event: "success",
            when: this.evh_1040167445267876_success_4877_getWhen,
            displayName: "setData",
        });
        const act_1040167445267876_rest_4876 = new core_1.actions.RestAction({
            actionArgs: this.act_1040167445267876_rest_4876_getActionArgs,
            displayName: "save",
            events: [evh_1040167445267876_success_4877],
        });
        const evh_1040167445267876_submit_4875 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_rest_4876,
            event: "submit",
            displayName: "save",
        });
        const evh_1040167445267876_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_submit_4875],
        });
        return {
            act_7315092382398562_closeModal_4864,
            evh_7315092382398562_close_4863,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_4866,
            evh_2248226175642056_close_4865,
            evh_2248226175642056_close,
            act_6466705138206980_script_4868,
            evh_6466705138206980_optionSelected_4867,
            evh_6466705138206980_optionSelected,
            act_8320016629450276_reloadComponentData_4870,
            evh_8320016629450276_clickPreventStop_4869,
            evh_8320016629450276_clickPreventStop,
            act_8116269939469002_showModal_4872,
            evh_8116269939469002_clickPreventStop_4871,
            evh_8116269939469002_clickPreventStop,
            act_1655522927138420_showModal_4874,
            evh_1655522927138420_clickPreventStop_4873,
            evh_1655522927138420_clickPreventStop,
            act_1040167445267876_setData_4878,
            evh_1040167445267876_success_4877,
            act_1040167445267876_rest_4876,
            evh_1040167445267876_submit_4875,
            evh_1040167445267876_submit,
            reload: act_8320016629450276_reloadComponentData_4870,
            save: act_1040167445267876_rest_4876,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Templates.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Templates.prototype, "onSize", null);
Templates = __decorate([
    (0, vue_property_decorator_1.Component)()
], Templates);
exports.default = Templates;
vue_property_decorator_1.Vue.component("Templates", Templates);
